import { createSlice } from '@reduxjs/toolkit';

type ProgramFormType = {
  programData: any;
};

const initialState: ProgramFormType = {
  programData: null,
};

const programData = createSlice({
  name: 'programData',
  initialState,
  reducers: {
    setProgramData(state, action) {
      const { payload } = action;
      state.programData = payload;
    },
    clearProgramData(state) {
      state.programData = null;
    },
  },
});

export const { setProgramData, clearProgramData } = programData.actions;

export default programData.reducer;
